document.addEventListener('DOMContentLoaded', function() {
    const rangeInputs = document.querySelectorAll('input[type="range"]')

    function handleInputChange(e) {
        const target = e.target
        const min = target.min
        const max = target.max
        const val = target.value

        const color = document.querySelector('.swiper-slide-active [data-color]').dataset.color;

        target.style.backgroundImage = `linear-gradient(90deg, ${color} ${((val - min) * 100 / (max - min) + 0.5 )}%, rgba(0,0,0,0) ${((val - min) * 100 / (max - min) + 0.5)}%)`
        e.target.previousElementSibling.querySelector('.cost').innerHTML = e.target.dataset.start + target.value + e.target.dataset.end;

        calc_result();
    }

    rangeInputs.forEach(input => {
        input.addEventListener('input', handleInputChange)
    })

    calc_result();

    function calc_result(){
        if ($(".swiper-slide.swiper-slide-active [data-interest-rate]").length < 1) return;

        var selectedAmount = $('[name=cost]').val();
        var selectedPeriod = $('[name=month]').val();
        var interestRateRaw = $(".swiper-slide.swiper-slide-active [data-interest-rate]").data('interest-rate').replace(/,/g, '.')
        var interestRatePercentage = parseFloat(interestRateRaw).toFixed(2);

        const monthlyInterestRate = interestRatePercentage / 12 / 100;
        const monthlyAmount = (selectedAmount * monthlyInterestRate) / (1 - Math.pow(1 + monthlyInterestRate, -1 * selectedPeriod));

        $(".costs--number-title").text(monthlyAmount.toFixed(2));
    }
});

